import * as React from 'react';

import { ServiceAds } from '../service_ads/service_ads';

const s = require('./sale_item_block.css');

interface IProps {
  onAdsClick(eventLabel: string): void;
}

export const SaleAdsBlock = (props: IProps) =>
  <div className={`${s['c-bottom-selfads-col']} cg-col-12`}>
    <ServiceAds
      class={`${s['c-selfads-item-add']} ${s['c-selfads-item']}`}
      onClick={() => props.onAdsClick('add_adv')}
      title="Размещайте объявления"
      description="Новая форма подачи позволит быстро и удобно разместить объявление"
      buttonText="Добавить объявление"
      buttonUrl="/realty/add1.aspx"
      isNewTab
    />
  </div>;
